import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

const assignPlanToWlOrg = (orgId, plans, assign, callback) => {
  return async (dispatch) => {
    dispatch({ type: 'UPDATING_WL_ORGANIZATION_PLANS' });
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const userInfo = localStorage.getItem('userInfo');
        const userId = JSON.parse(userInfo)?.id;
        const reqId = uuidv4();
        try {
          const response = await axios.post(`/ads/org/${orgId}/plan`, plans, {
            params: {
              'request-id': reqId,
              assignOrUnAssign: assign,
            },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          if (response.status === 200) {
            await dispatch({
              type: 'UPDATING_WL_ORGANIZATION_PLANS_DONE',
            });
            if (typeof callback === 'function') {
              callback(response?.data);
            }
          } else {
            dispatch({
              type: 'UPDATING_WL_ORGANIZATION_PLANS_FAILED',
              payload: `Failed to update wl org plans`,
            });
          }
        } catch (e) {
          dispatch({
            type: 'UPDATING_WL_ORGANIZATION_PLANS_FAILED',
            payload: `Failed to update wl org plans`,
          });
        }
        unsubscribe();
      });
    } catch (e) {
      console.log(e);
      dispatch({
        type: 'UPDATING_WL_ORGANIZATION_PLANS_FAILED',
        payload: `Failed to update wl org plans`,
      });
    }
  };
};

export default assignPlanToWlOrg;
